import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";

import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  ContentSideBySideCustom,
  Hero,
  Gallery,
  News,
  FeatureCard,
  Stats,
  SpacerV,
  FeatureCardSmall,
  SpacerH,
} from "../components/Hero";
import { Grid } from "@mui/material";
import { Up, Down, Left, Right } from "../components/PositionFade";
import {
  LeftInView,
  RightInView,
  UpInView,
  DownInView,
} from "../components/PositionFade";
import { useInView, useSpring, animated } from "@react-spring/web";
import { config } from "react-spring";

import {
  useSpringCarousel,
  useTransitionCarousel,
} from "react-spring-carousel";
import { TypeAnimation } from "react-type-animation";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import CellTowerIcon from "@mui/icons-material/CellTower";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import CheckroomIcon from "@mui/icons-material/Checkroom";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { useNavigate } from "react-router";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import WorkIcon from "@mui/icons-material/Work";
import AutoGraphIcon from "@mui/icons-material/AutoGraph";
import BuildIcon from "@mui/icons-material/Build";
import EngineeringIcon from "@mui/icons-material/Engineering";
import PersonIcon from "@mui/icons-material/Person";
import Lottie from "react-lottie";
import Carousel from "react-spring-3d-carousel";
import background from "../img/1.jpg";

import { API_URL } from "../actions/auth";
import axios from "axios";
{
  /* <video src={require("../img/2.mp4")} autoPlay loop muted></video> */
}
function makeid(length) {
  var result = "";
  var characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export default function Dashboard() {
  const timelineDelays = [0, 300, 600];

  const state = useSelector((state) => state);

  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(API_URL + "get_news")
      .then((res) => {
        setNews(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        console.error("Error fetching news:", err);
        setNews([]);
      });
    axios
      .get(API_URL + "get_gallery")
      .then((res) => {
        setGallery(Array.isArray(res.data) ? res.data : []);
      })
      .catch((err) => {
        console.error("Error fetching gallery:", err);
        setGallery([]);
      });
  }, []);

  const [news, setNews] = useState([]);
  const [gallery, setGallery] = useState([]);

  const [zoom1, zoom1api] = useSpring(() => ({
    from: { transform: "scale(1)" },
  }));

  const [zoom2, zoom2api] = useSpring(() => ({
    from: { transform: "scale(1)" },
  }));

  const { carouselFragment, slideToPrevItem, slideToNextItem } =
    useSpringCarousel({
      withLoop: true,
      items: [
        {
          id: "item-1",
          renderItem: (
            <section>
              <div class="overlay2"></div>
              <img
                className={"imgback"}
                style={{
                  transform: state.auth.isMobile ? "scale(1)" : "scale(0.75)",
                }}
                src={require("../img/1.jpg")}
              />
              <div className={"vidhero"}>
                <Grid style={{ width: "100%" }} container>
                  <Grid
                    item
                    md={7}
                    xs={12}
                    sm={12}
                    style={{
                      height: "100%",
                      width: "100%",
                      textAlign: "left",
                      display: "flex",
                      justifyContent: "start",
                      flexDirection: "column",
                      alignItems: "start",
                      marginLeft: state.auth.isMobile ? 0 : "150px",
                    }}
                  >
                    <TypeAnimation
                      sequence={["AI Revolution", 1000]}
                      wrapper="span"
                      cursor={false}
                      speed={50}
                      style={{
                        fontSize: state.auth.isMobile ? "72px" : "22px",
                        display: "inline-block",
                        lineHeight: "20px",
                        fontWeight: 600,
                        color: "cyan",
                        position: state.auth.isMobile ? "absolute" : "static",
                        top: state.auth.isMobile ? "100px" : 0,
                        left: state.auth.isMobile ? "52px" : 0,
                      }}
                    />
                    <animated.div
                      onClick={() => {
                        slideToNextItem();
                      }}
                      onMouseEnter={() => {
                        zoom1api.start({
                          from: {
                            transform: "scale(1)",
                          },
                          to: {
                            transform: "scale(1.1)",
                          },
                        });
                      }}
                      onMouseLeave={() => {
                        zoom1api.start({
                          from: {
                            transform: "scale(1.1)",
                          },
                          to: {
                            transform: "scale(1)",
                          },
                        });
                      }}
                      style={{
                        display: state.auth.isMobile ? "none" : "flex",
                        position: "absolute",
                        width: "80px",
                        height: "80px",
                        border: "2px solid white",
                        borderRadius: "100px",
                        top: "20vh",
                        right: 75,
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        ...zoom1,
                      }}
                    >
                      <ArrowRightIcon
                        style={{ fontSize: "75px", color: "white" }}
                      />
                    </animated.div>
                    <animated.div
                      onClick={() => {
                        slideToPrevItem();
                      }}
                      onMouseEnter={() => {
                        zoom2api.start({
                          from: {
                            transform: "scale(1)",
                          },
                          to: {
                            transform: "scale(1.1)",
                          },
                        });
                      }}
                      onMouseLeave={() => {
                        zoom2api.start({
                          from: {
                            transform: "scale(1.1)",
                          },
                          to: {
                            transform: "scale(1)",
                          },
                        });
                      }}
                      style={{
                        display: state.auth.isMobile ? "none" : "flex",
                        position: "absolute",
                        width: "80px",
                        height: "80px",
                        border: "2px solid white",
                        borderRadius: "100px",
                        top: "32vh",
                        right: 75,
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        ...zoom2,
                      }}
                    >
                      <ArrowLeftIcon
                        style={{ fontSize: "75px", color: "white" }}
                      />
                    </animated.div>
                    <br />
                    <Down delay={1000}>
                      <div
                        style={{
                          marginLeft: state.auth.isMobile ? "-52px" : 0,
                          fontSize: state.auth.isMobile ? "6vh" : "6vh",
                          display: "inline-block",
                          lineHeight: "70px",
                          fontWeight: 600,
                        }}
                      >
                        Empower your future with AI-driven solutions
                      </div>
                    </Down>
                    <br /> <br />
                    {!state.auth.isMobile ? (
                      <Grid style={{ width: "100%" }} container>
                        <Grid item xs={12} md={6}>
                          <Right delay={2000}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Advanced Analytics
                              </div>
                            </div>
                          </Right>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Right delay={2100}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Intelligent Systems
                              </div>
                            </div>
                          </Right>
                        </Grid>
                      </Grid>
                    ) : (
                      ""
                    )}
                    {!state.auth.isMobile ? (
                      <Grid style={{ width: "100%" }} container>
                        <Grid item xs={12} md={6}>
                          <Right delay={2200}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Workflow Automation
                              </div>
                            </div>
                          </Right>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Right delay={2300}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Voice Recognition
                              </div>
                            </div>
                          </Right>
                        </Grid>
                      </Grid>
                    ) : (
                      ""
                    )}
                    {!state.auth.isMobile ? (
                      <Grid style={{ width: "100%" }} container>
                        <Grid item xs={12} md={6}>
                          <Right delay={2500}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Smart Recommendations
                              </div>
                            </div>
                          </Right>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Right delay={2600}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Custom AI Solutions
                              </div>
                            </div>
                          </Right>
                        </Grid>
                      </Grid>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                    sm={12}
                    style={{
                      height: "100%",
                      width: "100%",
                      textAlign: "left",
                      display: "flex",
                      justifyContent: "start",
                      flexDirection: "column",
                      alignItems: "start",
                    }}
                  ></Grid>
                </Grid>
              </div>
            </section>
          ),
        },
        {
          id: "item-2",
          renderItem: (
            <section>
              <div class="overlay2"></div>
              <img
                className={"imgback"}
                style={{
                  transform: state.auth.isMobile ? "scale(1)" : "scale(0.75)",
                }}
                src={require("../img/11.jpg")}
              />
              <div className={"vidhero"}>
                <Grid style={{ width: "100%" }} container>
                  <Grid
                    item
                    md={7}
                    xs={12}
                    sm={12}
                    style={{
                      height: "100%",
                      width: "100%",
                      textAlign: "left",
                      display: "flex",
                      justifyContent: "start",
                      flexDirection: "column",
                      alignItems: "start",
                      marginLeft: state.auth.isMobile ? 0 : "150px",
                    }}
                  >
                    <TypeAnimation
                      sequence={["Digital Evolution", 1000]}
                      wrapper="span"
                      cursor={false}
                      speed={50}
                      style={{
                        fontSize: "22px",
                        display: "inline-block",
                        lineHeight: "20px",
                        fontWeight: 600,
                        color: "cyan",
                        position: state.auth.isMobile ? "absolute" : "static",
                        top: state.auth.isMobile ? "100px" : 0,
                        left: state.auth.isMobile ? "52px" : 0,
                      }}
                    />
                    <animated.div
                      onClick={() => {
                        slideToNextItem();
                      }}
                      onMouseEnter={() => {
                        zoom1api.start({
                          from: {
                            transform: "scale(1)",
                          },
                          to: {
                            transform: "scale(1.1)",
                          },
                        });
                      }}
                      onMouseLeave={() => {
                        zoom1api.start({
                          from: {
                            transform: "scale(1.1)",
                          },
                          to: {
                            transform: "scale(1)",
                          },
                        });
                      }}
                      style={{
                        display: state.auth.isMobile ? "none" : "flex",
                        position: "absolute",
                        width: "80px",
                        height: "80px",
                        border: "2px solid white",
                        borderRadius: "100px",
                        top: "20vh",
                        right: 75,
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        ...zoom1,
                      }}
                    >
                      <ArrowRightIcon
                        style={{ fontSize: "75px", color: "white" }}
                      />
                    </animated.div>
                    <animated.div
                      onClick={() => {
                        slideToPrevItem();
                      }}
                      onMouseEnter={() => {
                        zoom2api.start({
                          from: {
                            transform: "scale(1)",
                          },
                          to: {
                            transform: "scale(1.1)",
                          },
                        });
                      }}
                      onMouseLeave={() => {
                        zoom2api.start({
                          from: {
                            transform: "scale(1.1)",
                          },
                          to: {
                            transform: "scale(1)",
                          },
                        });
                      }}
                      style={{
                        display: state.auth.isMobile ? "none" : "flex",
                        position: "absolute",
                        width: "80px",
                        height: "80px",
                        border: "2px solid white",
                        borderRadius: "100px",
                        top: "32vh",
                        right: 75,
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        ...zoom2,
                      }}
                    >
                      <ArrowLeftIcon
                        style={{ fontSize: "75px", color: "white" }}
                      />
                    </animated.div>
                    <br />
                    <Down delay={1000}>
                      <div
                        style={{
                          marginLeft: state.auth.isMobile ? "-52px" : 0,
                          fontSize: state.auth.isMobile ? "5vh" : "6vh",
                          display: "inline-block",
                          lineHeight: "70px",
                          fontWeight: 600,
                        }}
                      >
                        Discover the potential of digital transformation
                      </div>
                    </Down>
                    <br /> <br />
                    {!state.auth.isMobile ? (
                      <Grid style={{ width: "100%" }} container>
                        <Grid item xs={12} md={6}>
                          <Right delay={2000}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Cloud Solutions
                              </div>
                            </div>
                          </Right>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Right delay={2100}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                IoT Innovations
                              </div>
                            </div>
                          </Right>
                        </Grid>
                      </Grid>
                    ) : (
                      ""
                    )}
                    {!state.auth.isMobile ? (
                      <Grid style={{ width: "100%" }} container>
                        <Grid item xs={12} md={6}>
                          <Right delay={2200}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                AI Integration
                              </div>
                            </div>
                          </Right>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Right delay={2300}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Learning Algorithms
                              </div>
                            </div>
                          </Right>
                        </Grid>
                      </Grid>
                    ) : (
                      ""
                    )}
                    {!state.auth.isMobile ? (
                      <Grid style={{ width: "100%" }} container>
                        <Grid item xs={12} md={6}>
                          <Right delay={2500}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Automated Processes
                              </div>
                            </div>
                          </Right>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Right delay={2600}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Enhanced Customer Experience
                              </div>
                            </div>
                          </Right>
                        </Grid>
                      </Grid>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                    sm={12}
                    style={{
                      height: "100%",
                      width: "100%",
                      textAlign: "left",
                      display: "flex",
                      justifyContent: "start",
                      flexDirection: "column",
                      alignItems: "start",
                    }}
                  ></Grid>
                </Grid>
              </div>
            </section>
          ),
        },
        {
          id: "item-4",
          renderItem: (
            <section>
              <div class="overlay2"></div>
              <img
                className={"imgback"}
                style={{
                  transform: state.auth.isMobile ? "scale(1)" : "scale(0.75)",
                }}
                src={require("../img/22.jpg")}
              />
              <div className={"vidhero"}>
                <Grid style={{ width: "100%" }} container>
                  <Grid
                    item
                    md={7}
                    xs={12}
                    sm={12}
                    style={{
                      height: "100%",
                      width: "100%",
                      textAlign: "left",
                      display: "flex",
                      justifyContent: "start",
                      flexDirection: "column",
                      alignItems: "start",
                      marginLeft: state.auth.isMobile ? 0 : "150px",
                    }}
                  >
                    <TypeAnimation
                      sequence={["Network Innovations", 1000]}
                      wrapper="span"
                      cursor={false}
                      speed={50}
                      style={{
                        fontSize: "22px",
                        display: "inline-block",
                        lineHeight: "20px",
                        fontWeight: 600,
                        color: "cyan",
                        position: state.auth.isMobile ? "absolute" : "static",
                        top: state.auth.isMobile ? "100px" : 0,
                        left: state.auth.isMobile ? "52px" : 0,
                      }}
                    />
                    <animated.div
                      onClick={() => {
                        slideToNextItem();
                      }}
                      onMouseEnter={() => {
                        zoom1api.start({
                          from: {
                            transform: "scale(1)",
                          },
                          to: {
                            transform: "scale(1.1)",
                          },
                        });
                      }}
                      onMouseLeave={() => {
                        zoom1api.start({
                          from: {
                            transform: "scale(1.1)",
                          },
                          to: {
                            transform: "scale(1)",
                          },
                        });
                      }}
                      style={{
                        display: state.auth.isMobile ? "none" : "flex",
                        position: "absolute",
                        width: "80px",
                        height: "80px",
                        border: "2px solid white",
                        borderRadius: "100px",
                        top: "20vh",
                        right: 75,
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        ...zoom1,
                      }}
                    >
                      <ArrowRightIcon
                        style={{ fontSize: "75px", color: "white" }}
                      />
                    </animated.div>
                    <animated.div
                      onClick={() => {
                        slideToPrevItem();
                      }}
                      onMouseEnter={() => {
                        zoom2api.start({
                          from: {
                            transform: "scale(1)",
                          },
                          to: {
                            transform: "scale(1.1)",
                          },
                        });
                      }}
                      onMouseLeave={() => {
                        zoom2api.start({
                          from: {
                            transform: "scale(1.1)",
                          },
                          to: {
                            transform: "scale(1)",
                          },
                        });
                      }}
                      style={{
                        display: state.auth.isMobile ? "none" : "flex",
                        position: "absolute",
                        width: "80px",
                        height: "80px",
                        border: "2px solid white",
                        borderRadius: "100px",
                        top: "32vh",
                        right: 75,
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        ...zoom2,
                      }}
                    >
                      <ArrowLeftIcon
                        style={{ fontSize: "75px", color: "white" }}
                      />
                    </animated.div>
                    <br />
                    <Down delay={1000}>
                      <div
                        style={{
                          marginLeft: state.auth.isMobile ? "-52px" : 0,
                          fontSize: state.auth.isMobile ? "5vh" : "6vh",
                          display: "inline-block",
                          lineHeight: "70px",
                          fontWeight: 600,
                        }}
                      >
                        Cutting-edge networking for a connected world
                      </div>
                    </Down>
                    <br /> <br />
                    {!state.auth.isMobile ? (
                      <Grid style={{ width: "100%" }} container>
                        <Grid item xs={12} md={6}>
                          <Right delay={2000}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Infrastructure Solutions
                              </div>
                            </div>
                          </Right>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Right delay={2100}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Security Enhancements
                              </div>
                            </div>
                          </Right>
                        </Grid>
                      </Grid>
                    ) : (
                      ""
                    )}
                    {!state.auth.isMobile ? (
                      <Grid style={{ width: "100%" }} container>
                        <Grid item xs={12} md={6}>
                          <Right delay={2200}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Monitoring Systems
                              </div>
                            </div>
                          </Right>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Right delay={2300}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Cloud Connectivity
                              </div>
                            </div>
                          </Right>
                        </Grid>
                      </Grid>
                    ) : (
                      ""
                    )}
                    {!state.auth.isMobile ? (
                      <Grid style={{ width: "100%" }} container>
                        <Grid item xs={12} md={6}>
                          <Right delay={2500}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Virtual Networks
                              </div>
                            </div>
                          </Right>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Right delay={2600}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Latency Reduction
                              </div>
                            </div>
                          </Right>
                        </Grid>
                      </Grid>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                    sm={12}
                    style={{
                      height: "100%",
                      width: "100%",
                      textAlign: "left",
                      display: "flex",
                      justifyContent: "start",
                      flexDirection: "column",
                      alignItems: "start",
                    }}
                  ></Grid>
                </Grid>
              </div>
            </section>
          ),
        },
        {
          id: "item-3",
          renderItem: (
            <section>
              <div class="overlay2"></div>
              <img
                className={"imgback"}
                style={{
                  transform: state.auth.isMobile ? "scale(1)" : "scale(0.75)",
                }}
                src={require("../img/33.jpg")}
              />
              <div className={"vidhero"}>
                <Grid style={{ width: "100%" }} container>
                  <Grid
                    item
                    md={7}
                    xs={12}
                    sm={12}
                    style={{
                      height: "100%",
                      width: "100%",
                      textAlign: "left",
                      display: "flex",
                      justifyContent: "start",
                      flexDirection: "column",
                      alignItems: "start",
                      marginLeft: state.auth.isMobile ? 0 : "150px",
                    }}
                  >
                    <TypeAnimation
                      sequence={["Cyber Defense", 1000]}
                      wrapper="span"
                      cursor={false}
                      speed={50}
                      style={{
                        fontSize: "22px",
                        display: "inline-block",
                        lineHeight: "20px",
                        fontWeight: 600,
                        color: "cyan",
                        position: state.auth.isMobile ? "absolute" : "static",
                        top: state.auth.isMobile ? "100px" : 0,
                        left: state.auth.isMobile ? "52px" : 0,
                      }}
                    />
                    <animated.div
                      onClick={() => {
                        slideToNextItem();
                      }}
                      onMouseEnter={() => {
                        zoom1api.start({
                          from: {
                            transform: "scale(1)",
                          },
                          to: {
                            transform: "scale(1.1)",
                          },
                        });
                      }}
                      onMouseLeave={() => {
                        zoom1api.start({
                          from: {
                            transform: "scale(1.1)",
                          },
                          to: {
                            transform: "scale(1)",
                          },
                        });
                      }}
                      style={{
                        display: state.auth.isMobile ? "none" : "flex",
                        position: "absolute",
                        width: "80px",
                        height: "80px",
                        border: "2px solid white",
                        borderRadius: "100px",
                        top: "20vh",
                        right: 75,
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        ...zoom1,
                      }}
                    >
                      <ArrowRightIcon
                        style={{ fontSize: "75px", color: "white" }}
                      />
                    </animated.div>
                    <animated.div
                      onClick={() => {
                        slideToPrevItem();
                      }}
                      onMouseEnter={() => {
                        zoom2api.start({
                          from: {
                            transform: "scale(1)",
                          },
                          to: {
                            transform: "scale(1.1)",
                          },
                        });
                      }}
                      onMouseLeave={() => {
                        zoom2api.start({
                          from: {
                            transform: "scale(1.1)",
                          },
                          to: {
                            transform: "scale(1)",
                          },
                        });
                      }}
                      style={{
                        display: state.auth.isMobile ? "none" : "flex",
                        position: "absolute",
                        width: "80px",
                        height: "80px",
                        border: "2px solid white",
                        borderRadius: "100px",
                        top: "32vh",
                        right: 75,
                        justifyContent: "center",
                        alignItems: "center",
                        cursor: "pointer",
                        ...zoom2,
                      }}
                    >
                      <ArrowLeftIcon
                        style={{ fontSize: "75px", color: "white" }}
                      />
                    </animated.div>
                    <br />
                    <Down delay={1000}>
                      <div
                        style={{
                          marginLeft: state.auth.isMobile ? "-52px" : 0,
                          fontSize: state.auth.isMobile ? "5vh" : "6vh",
                          display: "inline-block",
                          lineHeight: "70px",
                          fontWeight: 600,
                        }}
                      >
                        Unyielding security for digital landscapes
                      </div>
                    </Down>
                    <br /> <br />
                    {!state.auth.isMobile ? (
                      <Grid style={{ width: "100%" }} container>
                        <Grid item xs={12} md={6}>
                          <Right delay={2000}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Threat Detection
                              </div>
                            </div>
                          </Right>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Right delay={2100}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Security Testing
                              </div>
                            </div>
                          </Right>
                        </Grid>
                      </Grid>
                    ) : (
                      ""
                    )}
                    {!state.auth.isMobile ? (
                      <Grid style={{ width: "100%" }} container>
                        <Grid item xs={12} md={6}>
                          <Right delay={2200}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Risk Assessment
                              </div>
                            </div>
                          </Right>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Right delay={2300}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Update Management
                              </div>
                            </div>
                          </Right>
                        </Grid>
                      </Grid>
                    ) : (
                      ""
                    )}
                    {!state.auth.isMobile ? (
                      <Grid style={{ width: "100%" }} container>
                        <Grid item xs={12} md={6}>
                          <Right delay={2500}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Incident Management
                              </div>
                            </div>
                          </Right>
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <Right delay={2600}>
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <AcUnitIcon
                                style={{
                                  fontSize: "22px",
                                  marginRight: "20px",
                                }}
                              />
                              <div
                                style={{
                                  fontSize: "22px",
                                  display: "inline-block",
                                  lineHeight: "50px",
                                }}
                              >
                                Response Strategies
                              </div>
                            </div>
                          </Right>
                        </Grid>
                      </Grid>
                    ) : (
                      ""
                    )}
                  </Grid>
                  <Grid
                    item
                    md={6}
                    xs={12}
                    sm={12}
                    style={{
                      height: "100%",
                      width: "100%",
                      textAlign: "left",
                      display: "flex",
                      justifyContent: "start",
                      flexDirection: "column",
                      alignItems: "start",
                    }}
                  ></Grid>
                </Grid>
              </div>
            </section>
          ),
        },
      ],
    });

  useEffect(() => {
    const timer = setInterval(() => {
      slideToNextItem();
    }, 10000);
    return () => {
      window.clearInterval(timer);
    };
  }, [slideToNextItem]);

  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div
          className="anigrad"
          style={{
            height: "100vh",
            maxWidth: "100vw",
            display: state.auth.isMobile ? "none" : "block",
          }}
        >
          <div style={{ width: "100%", height: "100%" }}>
            {carouselFragment}
          </div>
        </div>
        <div
          className="anigrad"
          style={{
            height: "100vh",
            maxWidth: "100vw",
            display: state.auth.isMobile ? "block" : "none",
          }}
        >
          <section>
            <div class="overlay2"></div>
            <img
              className={"imgback"}
              style={{
                transform: state.auth.isMobile ? "scale(1)" : "scale(0.75)",
              }}
              src={require("../img/1.jpg")}
            />
            <div className={"vidhero"}>
              <Grid style={{ width: "100%" }} container>
                <Grid
                  item
                  md={7}
                  xs={12}
                  sm={12}
                  style={{
                    height: "100%",
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                    marginLeft: state.auth.isMobile ? 0 : "150px",
                  }}
                >
                  <TypeAnimation
                    sequence={["AI Revolution", 1000]}
                    wrapper="span"
                    cursor={false}
                    speed={50}
                    style={{
                      fontSize: "22px",
                      display: "inline-block",
                      lineHeight: "20px",
                      fontWeight: 600,
                      color: "cyan",
                      position: state.auth.isMobile ? "absolute" : "static",
                      top: state.auth.isMobile ? "150px" : 0,
                      left: state.auth.isMobile ? "52px" : 0,
                    }}
                  />
                  <animated.div
                    onClick={() => {
                      slideToNextItem();
                    }}
                    onMouseEnter={() => {
                      zoom1api.start({
                        from: {
                          transform: "scale(1)",
                        },
                        to: {
                          transform: "scale(1.1)",
                        },
                      });
                    }}
                    onMouseLeave={() => {
                      zoom1api.start({
                        from: {
                          transform: "scale(1.1)",
                        },
                        to: {
                          transform: "scale(1)",
                        },
                      });
                    }}
                    style={{
                      display: state.auth.isMobile ? "none" : "flex",
                      position: "absolute",
                      width: "80px",
                      height: "80px",
                      border: "2px solid white",
                      borderRadius: "100px",
                      top: "20vh",
                      right: 75,
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      ...zoom1,
                    }}
                  >
                    <ArrowRightIcon
                      style={{ fontSize: "75px", color: "white" }}
                    />
                  </animated.div>
                  <animated.div
                    onClick={() => {
                      slideToPrevItem();
                    }}
                    onMouseEnter={() => {
                      zoom2api.start({
                        from: {
                          transform: "scale(1)",
                        },
                        to: {
                          transform: "scale(1.1)",
                        },
                      });
                    }}
                    onMouseLeave={() => {
                      zoom2api.start({
                        from: {
                          transform: "scale(1.1)",
                        },
                        to: {
                          transform: "scale(1)",
                        },
                      });
                    }}
                    style={{
                      display: state.auth.isMobile ? "none" : "flex",
                      position: "absolute",
                      width: "80px",
                      height: "80px",
                      border: "2px solid white",
                      borderRadius: "100px",
                      top: "32vh",
                      right: 75,
                      justifyContent: "center",
                      alignItems: "center",
                      cursor: "pointer",
                      ...zoom2,
                    }}
                  >
                    <ArrowLeftIcon
                      style={{ fontSize: "75px", color: "white" }}
                    />
                  </animated.div>
                  <br />
                  <Down delay={1000}>
                    <div
                      style={{
                        marginLeft: state.auth.isMobile ? "-52px" : 0,
                        fontSize: state.auth.isMobile ? "5vh" : "6vh",
                        display: "inline-block",
                        lineHeight: state.auth.isMobile ? "50px" : "70px",
                        fontWeight: 600,
                      }}
                    >
                      Empower your future with AI-driven solutions
                    </div>
                  </Down>
                  <br /> <br />
                  {!state.auth.isMobile ? (
                    <Grid style={{ width: "100%" }} container>
                      <Grid item xs={12} md={6}>
                        <Right delay={2000}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <AcUnitIcon
                              style={{
                                fontSize: "22px",
                                marginRight: "20px",
                              }}
                            />
                            <div
                              style={{
                                fontSize: "22px",
                                display: "inline-block",
                                lineHeight: "50px",
                              }}
                            >
                              Advanced Analytics
                            </div>
                          </div>
                        </Right>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Right delay={2100}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <AcUnitIcon
                              style={{
                                fontSize: "22px",
                                marginRight: "20px",
                              }}
                            />
                            <div
                              style={{
                                fontSize: "22px",
                                display: "inline-block",
                                lineHeight: "50px",
                              }}
                            >
                              Intelligent Systems
                            </div>
                          </div>
                        </Right>
                      </Grid>
                    </Grid>
                  ) : (
                    ""
                  )}
                  {!state.auth.isMobile ? (
                    <Grid style={{ width: "100%" }} container>
                      <Grid item xs={12} md={6}>
                        <Right delay={2200}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <AcUnitIcon
                              style={{
                                fontSize: "22px",
                                marginRight: "20px",
                              }}
                            />
                            <div
                              style={{
                                fontSize: "22px",
                                display: "inline-block",
                                lineHeight: "50px",
                              }}
                            >
                              Workflow Automation
                            </div>
                          </div>
                        </Right>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Right delay={2300}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <AcUnitIcon
                              style={{
                                fontSize: "22px",
                                marginRight: "20px",
                              }}
                            />
                            <div
                              style={{
                                fontSize: "22px",
                                display: "inline-block",
                                lineHeight: "50px",
                              }}
                            >
                              Voice Recognition
                            </div>
                          </div>
                        </Right>
                      </Grid>
                    </Grid>
                  ) : (
                    ""
                  )}
                  {!state.auth.isMobile ? (
                    <Grid style={{ width: "100%" }} container>
                      <Grid item xs={12} md={6}>
                        <Right delay={2500}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <AcUnitIcon
                              style={{
                                fontSize: "22px",
                                marginRight: "20px",
                              }}
                            />
                            <div
                              style={{
                                fontSize: "22px",
                                display: "inline-block",
                                lineHeight: "50px",
                              }}
                            >
                              Smart Recommendations
                            </div>
                          </div>
                        </Right>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Right delay={2600}>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <AcUnitIcon
                              style={{
                                fontSize: "22px",
                                marginRight: "20px",
                              }}
                            />
                            <div
                              style={{
                                fontSize: "22px",
                                display: "inline-block",
                                lineHeight: "50px",
                              }}
                            >
                              Custom AI Solutions
                            </div>
                          </div>
                        </Right>
                      </Grid>
                    </Grid>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid
                  item
                  md={6}
                  xs={12}
                  sm={12}
                  style={{
                    height: "100%",
                    width: "100%",
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "start",
                    flexDirection: "column",
                    alignItems: "start",
                  }}
                ></Grid>
              </Grid>
            </div>
          </section>
        </div>
        <div style={{ height: "100px", backgroundColor: "white" }} />
        <div
          style={{
            fontSize: state.auth.isMobile ? "30px" : "40px",
            color: themeStyle.primaryColor,
            zIndex: 999,
            backgroundColor: "white",
            fontWeight: 600,
          }}
        >
          Transform Your Business With Cutting-Edge Technologies
        </div>
        <News
          gallery={gallery.map((gall, index) => ({
            subtitle: gall["subtitle"],
            title: gall["title"],
            image: API_URL + gall["image"],
            page: gall["page"],
          }))}
        />
        <ContentSideBySideCustom
          background={"white"}
          title="Embracing Technological Innovation"
          subtitle="Embracing technological innovation and change is essential in today’s rapidly evolving world. It enables businesses to enhance efficiency, foster creativity, and stay competitive. Adopting new technologies like AI, cloud computing, and blockchain unlocks opportunities for growth and transformation. However, true innovation requires a cultural shift, encouraging agility, collaboration, and continuous learning."
          image={
            // <img
            //   style={{ height: "100%", width: "100%" }}
            //   src={require("../img/cn-new.jpg")}
            // />
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/marketing (6).json"),
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={400}
              width={400}
              isStopped={false}
              isPaused={false}
            />
          }
        />

        <SpacerV height={"100px"} />

        {/* <div
          className={"anigrad"}
          style={{
            paddingTop: "50px",
            paddingBottom: "100px",
          }}
        >
          <TabContext value={value}>
            {!state.auth.isMobile ? (
              <Box
                sx={{
                  borderBottom: 1,
                  borderColor: "divider",
                  display: "flex",
                  justifyContent: "center",
                  fontSize: "50px",
                  background: "transparent",
                  maxWidth: "100vw",
                }}
              >
                <TabList
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  <Tab
                    label="VR/AR"
                    value="1"
                    style={{ fontSize: "22px", color: "white" }}
                  />
                  <Tab
                    label="Digital Twinning"
                    value="2"
                    style={{ fontSize: "22px", color: "white" }}
                  />
                  <Tab
                    label="METAVERSE"
                    value="3"
                    style={{ fontSize: "22px", color: "white" }}
                  />
                  <Tab
                    label="Automation"
                    value="4"
                    style={{ fontSize: "22px", color: "white" }}
                  />
                  <Tab
                    label="Robotics"
                    value="5"
                    style={{ fontSize: "22px", color: "white" }}
                  />
                </TabList>
              </Box>
            ) : (
              <div style={{ marginBottom: "-100px" }} />
            )}
            <TabPanel value="1">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"white"}
                subtitleColor={"#ddd"}
                titleFontSize={"22px"}
                subtitleFontSize={"20px"}
                title="Unlock Efficiency and Innovation with Smart Automation"
                subtitle="Experience the future of business operations with our Smart Automation solutions. We specialize in process optimization, reducing manual tasks, and incorporating modern automation technology. Our experts optimize operations and increase productivity by combining artificial intelligence, machine learning, and robotic process automation. By embracing our smart automation services, you can achieve cost savings, reduce errors, and free up your workforce to focus on more strategic tasks."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={require("../img/cloud1.png")}
                  ></img>
                }
              />
            </TabPanel>
            <TabPanel value="2">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"white"}
                subtitleColor={"#ddd"}
                titleFontSize={"22px"}
                subtitleFontSize={"20px"}
                title="Transforming the Future with AR/VR Solutions"
                subtitle="The primary advantage of AR/VR technology is its ability to merge digitally generated data with the physical world, making it an ideal tool for training staff, expanding your business, and much more with practical applications. Technologies not only make training easier, but they also make industry operations easier on a daily basis, which can have a big impact on an organization's ability to expand. With our expertise in AR/VR technologies, we empower businesses to enhance their products, services, and customer interactions. From captivating virtual tours and interactive training simulations to immersive marketing campaigns and engaging educational experiences, our solutions transcend boundaries and create unforgettable moments."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={require("../img/cloud2.png")}
                  ></img>
                }
              />
            </TabPanel>
            <TabPanel value="3">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"white"}
                titleFontSize={"22px"}
                subtitleFontSize={"20px"}
                title="Connecting Physical and Digital Realities"
                subtitle="In today's digital era, the concept of Digital Twinning has emerged as a game-changer in various industries, offering unprecedented opportunities for innovation and optimization. From manufacturing and healthcare to transportation and smart cities, Digital Twinning is reshaping the way we design, monitor, and manage systems and processes. Through the seamless integration of digital versions of physical assets or systems, we enable organizations unprecedented capabilities for monitoring, analyzing, and optimizing their operations. Our expertise lies in developing precise and dynamic digital twins that replicate physical assets in real time. Our solutions provide unmatched insights into performance, predictive maintenance, and process optimization across all industries from manufacturing facilities and smart buildings to entire cities."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={require("../img/cloud6.png")}
                  ></img>
                }
              />
            </TabPanel>
            <TabPanel value="4">
              {" "}
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"white"}
                titleFontSize={"22px"}
                subtitleFontSize={"20px"}
                title="Step into the Future with Our Metaverse Solutions"
                subtitle="A collective virtual shared space, created by the convergence of physical and digital realities. It is a place where users can interact with each other and digital objects in real-time, blurring the lines between the physical and virtual worlds. From virtual reality (VR) to augmented reality (AR) and everything in between, the metaverse offers a truly immersive experience like never before. Embark on an extraordinary journey into the Metaverse with CGT Solutions. Our innovative Metaverse Solutions redefine digital interaction, offering immersive experiences that transcend traditional boundaries. From virtual events and social gatherings to immersive gaming experiences and interactive commerce, our Metaverse Solutions cater to diverse needs and ambitions."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={require("../img/cloud4.png")}
                  ></img>
                }
              />
            </TabPanel>
            <TabPanel value="5">
              <ContentSideBySideCustom
                background={"transparent"}
                titleColor={"white"}
                subtitleColor={"#ddd"}
                titleFontSize={"22px"}
                subtitleFontSize={"20px"}
                title="Transform Your Operations with Advanced Robotic Solutions"
                subtitle="In today's rapidly advancing technological landscape, robotics has emerged as a game-changer across various industries. From manufacturing to healthcare, robotics solutions are revolutionizing processes, increasing efficiency, and driving innovation like never before. If you are looking to stay ahead of the curve and embrace the future of automation, look no further than our advanced robotic solutions. Our robotic solutions, which prioritize scalability, adaptability, and reliability, enable companies to reach unprecedented heights of productivity and profitability. The advantages of our robotic systems are truly transformative, ranging from cost reduction and error minimization to throughput enhancement and improved worker safety."
                image={
                  <img
                    style={{
                      height: "50vh",
                      width: "100%",
                      objectFit: "cover",
                    }}
                    src={require("../img/cloud5.png")}
                  ></img>
                }
              />
            </TabPanel>
          </TabContext>
        </div>
        <SpacerV height={"50px"} />
        <div
          style={{
            borderRadius: "25px",
            fontSize: state.auth.isMobile ? "30px":"40px",
            color: themeStyle.primaryColor,
            fontWeight: 600,
            backgroundColor: "white",
          }}
        >
          Pioneering New Frontiers
        </div>
        <ThreeSideBySide
          spacing={5}
          subtitle1={
            <div
              onClick={() => navigate("/ai_ml")}
              className="anigrad"
              style={{
                minHeight: "36vh",
                padding: "20px",
                paddingTop: "15px",
                borderRadius: "10px",
                width: "100%",
                justifyContent: "flex-start",
                flexDirection: "column",
                alignItems: "flex-start",
                display: "flex",
              }}
            >
              <div style={{ width: "100%" }}>
                <div
                  style={{
                    display: "flex",
                    color: "white",
                    fontWeight: 600,
                    fontSize: "30px",
                    marginBottom: "30px",
                  }}
                >
                  AI and Machine Learning
                </div>
                <div
                  style={{
                    margin: "5px 0px 5px 0px",
                    padding: "10px 0px 10px 0px",
                    fontWeight: "600",
                    fontSize: "20px",
                    borderBottom: "2px solid white",
                    cursor: "pointer",

                    width: "100%",
                    color: "white",
                  }}
                >
                  Intelligent Systems
                </div>
                <div
                  style={{
                    margin: "5px 0px 5px 0px",
                    padding: "10px 0px 10px 0px",
                    fontWeight: "600",
                    fontSize: "20px",
                    borderBottom: "2px solid white",
                    cursor: "pointer",
                    width: "100%",
                    color: "white",
                  }}
                >
                  Conversational AI
                </div>
                <div
                  style={{
                    margin: "5px 0px 5px 0px",
                    padding: "10px 0px 10px 0px",
                    fontWeight: "600",
                    fontSize: "20px",
                    borderBottom: "2px solid white",
                    cursor: "pointer",
                    width: "100%",
                    color: "white",
                  }}
                >
                  AI Integrations
                </div>
                <div
                  style={{
                    margin: "5px 0px 5px 0px",
                    padding: "10px 0px 10px 0px",
                    fontWeight: "600",
                    fontSize: "20px",
                    borderBottom: "2px solid white",
                    cursor: "pointer",
                    width: "100%",
                    color: "white",
                  }}
                >
                  AI-Powered Websites
                </div>
                <div
                  style={{
                    margin: "5px 0px 5px 0px",
                    padding: "10px 0px 10px 0px",
                    fontWeight: "600",
                    fontSize: "20px",
                    borderBottom: "2px solid white",
                    cursor: "pointer",
                    width: "100%",
                    color: "white",
                  }}
                >
                  Generative AI Solutions
                </div>
                <div
                  style={{
                    margin: "5px 0px 5px 0px",
                    padding: "10px 0px 10px 0px",
                    fontWeight: "600",
                    fontSize: "20px",
                    cursor: "pointer",
                    width: "100%",
                    color: "white",
                  }}
                >
                  Chatbots
                </div>
              </div>
            </div>
          }
          subtitle2={
            <div
              onClick={() => navigate("/marketing")}
              className="anigrad"
              style={{
                minHeight: "36vh",
                padding: "20px",
                paddingTop: "15px",
                borderRadius: "10px",
                width: "100%",
                justifyContent: "flex-start",
                flexDirection: "column",
                alignItems: "flex-start",
                display: "flex",
              }}
            >
              <div style={{ width: "100%" }}>
                <div
                  style={{
                    display: "flex",
                    color: "white",
                    fontWeight: 600,
                    fontSize: "30px",
                    marginBottom: "30px",
                  }}
                >
                  Digital Marketing Strategies
                </div>
                <div
                  style={{
                    margin: "5px 0px 5px 0px",
                    padding: "10px 0px 10px 0px",
                    fontWeight: "600",
                    fontSize: "20px",
                    borderBottom: "2px solid white",
                    cursor: "pointer",
                    width: "100%",
                    color: "white",
                  }}
                >
                  Brand Development
                </div>
                <div
                  style={{
                    margin: "5px 0px 5px 0px",
                    padding: "10px 0px 10px 0px",
                    fontWeight: "600",
                    fontSize: "20px",
                    borderBottom: "2px solid white",
                    cursor: "pointer",
                    width: "100%",
                    color: "white",
                  }}
                >
                  Brand Evaluation
                </div>
                <div
                  style={{
                    margin: "5px 0px 5px 0px",
                    padding: "10px 0px 10px 0px",
                    fontWeight: "600",
                    fontSize: "20px",
                    borderBottom: "2px solid white",
                    cursor: "pointer",
                    width: "100%",
                    color: "white",
                  }}
                >
                  Naming Services
                </div>
                <div
                  style={{
                    margin: "5px 0px 5px 0px",
                    padding: "10px 0px 10px 0px",
                    fontWeight: "600",
                    fontSize: "20px",
                    borderBottom: "2px solid white",
                    cursor: "pointer",
                    width: "100%",
                    color: "white",
                  }}
                >
                  Logo Creation
                </div>
                <div
                  style={{
                    margin: "5px 0px 5px 0px",
                    padding: "10px 0px 10px 0px",
                    fontWeight: "600",
                    fontSize: "20px",
                    borderBottom: "2px solid white",
                    cursor: "pointer",
                    width: "100%",
                    color: "white",
                  }}
                >
                  Visual Branding
                </div>
                <div
                  style={{
                    margin: "5px 0px 5px 0px",
                    padding: "10px 0px 10px 0px",
                    fontWeight: "600",
                    fontSize: "20px",
                    width: "100%",
                    color: "white",
                    cursor: "pointer",
                  }}
                >
                  Graphic Design
                </div>
              </div>
            </div>
          }
          subtitle3={
            <div
              onClick={() => navigate("/software")}
              className="anigrad"
              style={{
                minHeight: "36vh",
                padding: "20px",
                paddingTop: "15px",
                borderRadius: "10px",
                width: "100%",
                justifyContent: "flex-start",
                flexDirection: "column",
                alignItems: "flex-start",
                display: "flex",
              }}
            >
              <div style={{ width: "100%" }}>
                <div
                  style={{
                    display: "flex",
                    color: "white",
                    fontWeight: 600,
                    fontSize: "30px",
                    marginBottom: "30px",
                  }}
                >
                  Software Development
                </div>
                <div
                  style={{
                    margin: "5px 0px 5px 0px",
                    padding: "10px 0px 10px 0px",
                    fontWeight: "600",
                    fontSize: "20px",
                    borderBottom: "2px solid white",
                    cursor: "pointer",
                    width: "100%",
                    color: "white",
                  }}
                >
                  Web Development
                </div>
                <div
                  style={{
                    margin: "5px 0px 5px 0px",
                    padding: "10px 0px 10px 0px",
                    fontWeight: "600",
                    fontSize: "20px",
                    borderBottom: "2px solid white",
                    cursor: "pointer",
                    width: "100%",
                    color: "white",
                  }}
                >
                  Mobile App Development
                </div>
                <div
                  style={{
                    margin: "5px 0px 5px 0px",
                    padding: "10px 0px 10px 0px",
                    fontWeight: "600",
                    fontSize: "20px",
                    borderBottom: "2px solid white",
                    cursor: "pointer",
                    width: "100%",
                    color: "white",
                  }}
                >
                  Progressive Web Apps
                </div>
                <div
                  style={{
                    margin: "5px 0px 5px 0px",
                    padding: "10px 0px 10px 0px",
                    fontWeight: "600",
                    fontSize: "20px",
                    borderBottom: "2px solid white",
                    cursor: "pointer",
                    width: "100%",
                    color: "white",
                  }}
                >
                  Software Support
                </div>
                <div
                  style={{
                    margin: "5px 0px 5px 0px",
                    padding: "10px 0px 10px 0px",
                    fontWeight: "600",
                    fontSize: "20px",
                    borderBottom: "2px solid white",
                    cursor: "pointer",
                    width: "100%",
                    color: "white",
                  }}
                >
                  Enterprise Solutions
                </div>
                <div
                  style={{
                    margin: "5px 0px 5px 0px",
                    padding: "10px 0px 10px 0px",
                    fontWeight: "600",
                    fontSize: "20px",
                    width: "100%",
                    color: "white",
                    cursor: "pointer",
                  }}
                >
                  UI/UX Design
                </div>
              </div>
            </div>
          }
        />
        <div
          style={{
            fontSize: state.auth.isMobile ? "30px":"40px",
            color: themeStyle.primaryColor,
            zIndex: 999,
            backgroundColor: "white",
            fontWeight: 600,
          }}
        >
          Latest Insights and Innovations
        </div>
        <Gallery
          gallery={news.map((ne, index) => ({
            subtitle: ne["subtitle"],
            title: ne["title"],
            image: API_URL + ne["image"],
          }))}
        />
        <SpacerV height={"150px"} /> */}
        <div
          style={{
            fontSize: state.auth.isMobile ? "30px" : "40px",
            color: themeStyle.primaryColor,
            zIndex: 999,
            backgroundColor: "white",
            fontWeight: 600,
            marginTop: "-50px",
          }}
        >
          Discover Our Expertise
        </div>
        <Stats />

        <SpacerV height={"50px"} />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
